import React from "react";
import { Box, Stack, Skeleton } from "@mui/material";

const LabelValue = ({ labelW = 110, valueW = 120, minWidth = 180 }) => (
  <Stack spacing={0.5} sx={{ minWidth }}>
    <Skeleton variant="text" width={labelW} height={14} />
    <Skeleton variant="text" width={valueW} height={18} />
  </Stack>
);

const ActionBtn = () => (
  <Stack spacing={0.75} alignItems="center" sx={{ minWidth: 56 }}>
    <Skeleton variant="rounded" width={36} height={28} />
    <Skeleton variant="text" width={48} height={12} />
  </Stack>
);

const Card = () => (
  <Box
    sx={{
      border: "1px solid #F0F0F3",
      borderRadius: 2,
      background: "#fff",
      p: 1.25,
      display: "flex",
      flexDirection: "column",
      gap: 1.25,
    }}
  >
    {/* Details */}
    <Box
      sx={{
        border: "1px solid #EEF0F4",
        borderRadius: 2,
        p: 1.25,
        display: "flex",
        flexDirection: "column",
        gap: 1.25,
        background: "#FFF",
      }}
    >
      <Box sx={{ display: "flex", gap: 3, flexWrap: "wrap" }}>
        <LabelValue labelW={70} valueW={90} />
        <LabelValue labelW={90} valueW={70} />
      </Box>
      <Box sx={{ display: "flex", gap: 3, flexWrap: "wrap" }}>
        <LabelValue labelW={120} valueW={220} minWidth={260} />
        <LabelValue labelW={120} valueW={120} />
      </Box>
    </Box>

    {/* Action buttons */}
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        px: 0.5,
        pb: 0.5,
        flexWrap: "wrap",
        gap: 1,
      }}
    >
      {Array.from({ length: 5 }).map((_, i) => (
        <ActionBtn key={i} />
      ))}
    </Box>
  </Box>
);

const SelfListingSkeleton = ({ count = 1 }) => (
  <Stack spacing={1.25}>
    {Array.from({ length: count }).map((_, i) => (
      <Card key={i} />
    ))}
  </Stack>
);

export default SelfListingSkeleton;
